module.exports = __webpack_public_path__ + "img/add-cabang.232533d9.svg";